import React from "react";
import "./header.css";
import { Image } from 'react-bootstrap';


class Header extends React.Component {
	componentDidMount() {
		var video = document.getElementById("header-video");
		video.addEventListener( "canplay", function() {
			video.play();
		});
	}

  	render() {
	    return (
			<div id="header">
				<div className="header-title">
					<Image className="header-image" src="/media/typeface-logo.png" />
			  		<h2 className="text-center">Advanced Systems Design & Development</h2>
				</div>
				<video id="header-video" className="video" muted loop>
				  <source src="/media/keyboard.mp4" type="video/mp4" />
				  Your browser doesn't support HTML5 video. Here's a <a target="_blank" href="#">link</a> to download the video.
				</video>
			</div>
	    );
  	}
}

export default Header;


// WEBPACK FOOTER //
// ./src/ui/components/Header.js